export enum TippingMode {
  ONCE = 'once',
  PER_NIGHT = 'per_night',
  PER_STAY = 'per_stay',
}
